module.exports = __webpack_public_path__ + "img/facebook-light.2cf0c4d2.svg";